import React from "react";
import { IoClose } from "react-icons/io5";
import { useAuthStore } from "../../context/useAuthStore";
import logo from '../../assets/llb360.png'


interface TTSModalProps {
  userName: string;
  showModal: boolean;
  onClose: () => void;
}

const TTSModal: React.FC<TTSModalProps> = ({
  showModal,
  onClose,
}) => {

  const { user } = useAuthStore();

  if (!showModal) return null;
  
  return (
    <section
      className="modalSection"
      role="dialog"
      aria-modal="true"
      aria-labelledby="logout-title"
    >
      <div className="modalContainer">
        <div className="flex justify-between items-center gap-2 border-b pb-1 border-gray-200">
          <h1 className="logoutModalTitle mb-0 flex items-center"><img src={logo} alt="LLB360 Logo" className="w-12" loading="lazy"/>Text-to-Speech Disabled</h1>
          <button
            onClick={onClose}
            className="modalCloseButton"
            aria-label="Close modal"
          >
            <IoClose size={20} />
          </button>
        </div>
        <div className="logoutModalBody">
          <p className="logoutModalDesc text-start">
            Dear <span className="logoutModalUserName">{user?.fullName || "User"}</span>, it looks like text-to-speech is currently disabled on your device or browser. <br /><br />
            To hear content read aloud, please enable text-to-speech in your accessibility settings. 
          </p>
          <button
            onClick={onClose}
            className="defaultButton"
          >
            I understand
          </button>
        </div>
      </div>
    </section>
  );
};

export default TTSModal;